import { INavLinkItemProps } from "common/models/components/ui/INavLinkItemProps";
import { FC, memo } from "react";
import { NavLink } from "react-router-dom";

export const SidebarLinkItem: FC<INavLinkItemProps> = memo(
  ({ badge, ...props }) => {
    const userClasses = props.className || "";

    return (
      <NavLink
        {...props}
        className={({ isActive }) =>
          `flex w-full flex-col items-center justify-end ${
            isActive ? "text-primary" : "text-gray"
          } ${userClasses} py-[12px] outline-none transition hover:text-primary focus:text-primary active:text-graySecond`
        }
      >
        {props.icon}
        <span
          className={`font-semibold} relative mt-[4px] text-center text-sm`}
        >
          {props.label}
          {!!badge && (
            <span
              aria-label={`Непрочитанных: ${badge}`}
              className="absolute -top-[6px] -right-[18px] flex h-[16px] min-w-[16px] items-center justify-center rounded-[50%] bg-primary px-[3px] text-xxs font-medium text-white"
            >
              {badge > 99 ? "99+" : badge}
            </span>
          )}
        </span>
      </NavLink>
    );
  }
);
